/**
 * otuma-lenis.js
 * Smooth scroll solo en desktop (no touch).
 * Reconecta los IntersectionObservers de otuma al scroll de Lenis.
 */
(function () {
  'use strict';

  /* ── Solo desktop ── */
  var isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
  if (isTouch) return;

  /* ── Carga Lenis desde CDN ── */
  var script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/@studio-freight/lenis@1.0.42/dist/lenis.min.js';
  script.onload = init;
  document.head.appendChild(script);

  function init() {
    if (typeof Lenis === 'undefined') return;

    var lenis = new Lenis({
      lerp: 0.1,
      smoothWheel: true,
      smoothTouch: false,
      wheelMultiplier: 1,
      touchMultiplier: 0,
    });

    /* ── RAF loop ── */
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    /* ── Exponer globalmente para otros scripts ── */
    window.otumaLenis = lenis;

    /* ── Reconectar IntersectionObservers ──
       Lenis no rompe los observers nativos en Chrome/Firefox,
       pero en algunos builds de Safari desktop el scroll sintético
       puede desfasar el rootMargin. Forzamos re-check en cada tick de Lenis. */
    var watchedEls = [];

    function registerForWatch(selector, onVisible) {
      var el = document.querySelector(selector);
      if (!el) return;
      watchedEls.push({ el: el, cb: onVisible, triggered: false });
    }

    /* Oficio */
    registerForWatch('[data-otuma-oficio]', function (el) {
      el.classList.add('is-revealed');
      /* Dispara partículas si existen */
      var event = new CustomEvent('otuma:reveal-oficio');
      el.dispatchEvent(event);
    });

    /* La casa */
    registerForWatch('[data-otuma-casa]', function (el) {
      el.classList.add('is-in');
    });

    /* Teaser */
    registerForWatch('[data-otuma-teaser]', function (el) {
      el.classList.add('is-in');
    });

    /* Favoritos (no tiene reveal animado, pero lo registramos por si se agrega) */
    /* registerForWatch('.otuma-favoritos', function (el) {}); */

    /* En cada scroll de Lenis chequeamos visibilidad */
    lenis.on('scroll', function () {
      watchedEls.forEach(function (item) {
        if (item.triggered) return;
        var rect = item.el.getBoundingClientRect();
        var visible = rect.top < window.innerHeight * 0.88 && rect.bottom > 0;
        if (visible) {
          item.triggered = true;
          item.cb(item.el);
        }
      });
    });

    /* Chequeo inicial por si ya están en viewport al cargar */
    setTimeout(function () {
      watchedEls.forEach(function (item) {
        if (item.triggered) return;
        var rect = item.el.getBoundingClientRect();
        var visible = rect.top < window.innerHeight * 0.88 && rect.bottom > 0;
        if (visible) {
          item.triggered = true;
          item.cb(item.el);
        }
      });
    }, 200);

    /* ── Anclar links internos con Lenis ── */
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        lenis.scrollTo(target, { offset: -80, duration: 1.2 });
      });
    });

    /* ── Pausar Lenis cuando hay un modal abierto ──
       Los modales de favoritos y el quick view necesitan scroll libre dentro. */
    var modalObserver = new MutationObserver(function () {
      var hasModal = document.querySelector('.otuma-qv.open, .otuma-custom.open');
      if (hasModal) {
        lenis.stop();
      } else {
        lenis.start();
      }
    });
    modalObserver.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }
})();